// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-classManagement-index-main_right_content-3U710","table":"components-classManagement-index-table-2Yjqr"};


//////////////////
// WEBPACK FOOTER
// ./components/classManagement/index.css
// module id = 811
// module chunks = 0